module.exports = function(exec){
  try {
    return !!exec();
  } catch(e){
    return true;
  }
};


//////////////////
// WEBPACK FOOTER
// /app/node_modules/core-js/library/modules/_fails.js
// module id = 130
// module chunks = 0